import { useMemo } from 'react';
import { useQuery, useMutation } from 'react-query';
import { getCoupon, getCouponGroup, getCouponDetail, cancelCoupon, errorHandler } from 'apis';
import { CouponDetailResponse } from 'interfaces/store';

export const useCoupon = (sid: string | undefined, date: string) => {
  const params = useMemo(() => {
    if (!!sid && !!date) {
      return { sid, date };
    }
    return null;
  }, [sid, date]);
  return useQuery(['getCoupon', params], () => !!params && getCoupon(params), {
    enabled: !!sid && !!date
  });
};

export const useCouponGroup = (
  page: number,
  pageRow: number,
  sid: string | undefined,
  date: string,
  payRoomIdx?: string,
  onSuccess?: (result: any) => void
) => {
  const params = useMemo(() => {
    if (!!page && !!sid && !!date) {
      const base = { sid, date, page, pageRow } as const;
      if (payRoomIdx) {
        return { ...base, payRoomIdx };
      }
      return base;
    }
    return null;
  }, [sid, date, page, pageRow, payRoomIdx]);
  return useQuery(['getCouponGroup', params], () => !!params && getCouponGroup(params), {
    enabled: !!page && !!sid && !!date,
    onSuccess
  });
};

export const useCouponDetail = (couponId: string | undefined, params: any) => {
  return useQuery<CouponDetailResponse>(
    ['getCouponDetail', couponId, params],
    () => !!params && getCouponDetail(couponId, params),
    {
      enabled: !!couponId && !!params
    }
  );
};

export const useCancelCoupon = (onSuccess?: () => void) => {
  return useMutation(
    ['cancelCoupon'],
    ({ couponId, cancelMessage }: { couponId: string; cancelMessage: string }) => cancelCoupon(couponId, cancelMessage),
    {
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error) => {
        errorHandler(error);
      }
    }
  );
};
